module.exports = __webpack_public_path__ + "media/reskin-images/img--get-access-bg-523a05a0.svg";